import { replaceContextPath } from '../PathUtils';
import { prepareLoginHelpLocale } from '../uc-login/Utils';

const submitForm = (config, e, isLegacy, onLoginSubmit) => {
    const url = `${config.context}/app/initialLogin`;
    const form = document.createElement('form');
    form.style.display = 'none';

    const appendElement = (name, value) => {
        const element = document.createElement('INPUT');
        element.name = name;
        element.value = value;
        element.type = 'hidden';
        form.appendChild(element);
    };

    form.method = 'POST';
    form.action = url;

    appendElement('userid', e.username);
    appendElement('password', e.password);
    document.body.appendChild(form);

    if (isLegacy) {
        form.submit();
    } else {
        onLoginSubmit({
            target: {
                form,
            },
        });
    }
};

const selectLink = (e, config, isLegacy) => {
    const { item } = e ?? {};
    const { propertyName, link } = item ?? {};

    if (propertyName && propertyName === 'troubleTestingLinkTestLabel') {
        window.open(
            `${
                config.staticResourcesContext
            }/static/html/${prepareLoginHelpLocale()}.html#compatibility_test`,
        );
    } else if (link) {
        let queryString = '';
        const { unAuthenticatedAllowedUser } = config;

        if (
            propertyName === 'registerLinkLabel' &&
            unAuthenticatedAllowedUser
        ) {
            queryString = '?ui=new';
        }

        let replacedLink = link;

        if (!isLegacy) {
            replacedLink = replaceContextPath(link, true);
        }
        window.location.href = `${replacedLink}${queryString || ''}`;
    }
};

export default {};
export { submitForm, selectLink };
